




















































































































































































































import { Vue, Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { ComponentBaseMixin } from "@/mixins/component-base.mixin";
import PromenaLozinke from "@/views/Korisnici/PromenaLozinke.vue";

@Component({
  components: {PromenaLozinke}
})
export default class Korisnici extends mixins(ComponentBaseMixin) {
    columns = [];
    registrovaniKorisnici = [];
    prikaziPromenuLozinke = false;

    tableOptions = {
        search: true,
        pagination: true,
        sortable: true,
        onClickRow: (row) => this.onClickRow(row),
    };

    user = {
        id: "",
        firstName: "",
        lastName: "",
        photo: "",
        eMail: "",
        phoneNumber: "",
        role: "merchandiser",
        deviceCode: "",
    };

    roles = ["Merchandiser", "Manager"];
    isBusySave = false;

    created() {
        this.columns = [
            { field: "firstName", title: this.$i18n.t("ime"), sortable: true },
            {
                field: "lastName",
                title: this.$i18n.t("prezime"),
                sortable: true,
            },
            { field: "email", title: this.$i18n.t("email") },
        ];
    }

    mounted() {
        (<any>this.$refs.observer).validate();
        this.loadUsers();
    }

    async loadUsers() {
        let table = $("#registrovaniKorisnici");
        table.bootstrapTable("showLoading");
        await this.axios
            .get("api/GetUsers")
            .then((result) => {
                this.registrovaniKorisnici = result.data;
                console.log(result.data);
            })
            .catch((err) => {
                this.showError("neuspesnoUcitavanjePodataka");
                table.bootstrapTable("hideLoading");
            })
            .finally(() => {
                table.bootstrapTable("hideLoading");
            });
    }

    onClickRow(row) {
        this.user = row;
    }

    async saveUser() {
        this.isBusySave = true;
        try {
            await this.axios.post("api/SaveUser", this.user);
            this.loadUsers();
            this.showInfo("podaciUspesnoSacuvani");
            this.isBusySave = false;
        } catch (err) {
            this.showError("neuspesnoCuvanjePodataka");
            this.isBusySave = false;
        }
    }

    noviKorisnik() {
        this.user = {
            id: "",
            firstName: "",
            lastName: "",
            photo: "",
            eMail: "",
            phoneNumber: "",
            role: "merchandiser",
            deviceCode: "",
        };
    }

    promeniLozinku() {
      this.prikaziPromenuLozinke = true;
    }
}
